/**
 * API url
 * @type {string}
 */
export const API_URL = "https://api.smartapresentkort.se/api";

export default { API_URL }
